<div class="card rounded-top-left-0">
  <div class="card-header">
    <h1>Asociar Destino con Listas de Precio</h1>
  </div>

  <div class="card-body">
    <div class="mb-3 d-flex gap-3 align-items-end flex-wrap">
      <div class="text-muted">
        <i class="fa fa-circle-info"></i>
        Selecciona una <strong>Destino</strong> a la izquierda y marca las <strong>listas de precio</strong> a asociar a la derecha.  
        Una lista de precio puede estar asociada a una o más destinos.
      </div>
    </div>

    <div class="row">
      <svg id="svg-container" #svgContainer></svg>

      <!-- Tabla de Bodegas -->
      <div class="col">
        <div class="form-group">
          <label class="form-label">Buscar destino</label>
          <input type="text" [(ngModel)]="filterDestinations" (input)="debouncedFilterDestinations()"
                 class="form-control" placeholder="Nombre de destino" />
        </div>

        <div class="table-responsive mt-3">
          <table class="table table-bordered" id="table-destinations">
            <thead>
              <tr class="tr-middle">
                <th></th>
                <!-- <th>Código</th> -->
                <th>Nombre</th>
                <!-- <th>Establecimiento</th> -->
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let w of destinations"
                  [attr.data-id]="w.id"
                  (click)="selectDestination(w.id)"
                  [class.selected]="w.id === selectedDestinationId">
                <td>
                  <i [ngClass]="w.id === selectedDestinationId ? 'fa-solid fa-circle' : 'fa-regular fa-circle'"></i>
                </td>
                <!-- <td>{{ w.code }}</td> -->
                <td>{{ w.name }}</td>
                <!-- <td>{{ w.establishmentCode }}</td> -->
              </tr>

              <tr *ngIf="destinations.length === 0">
                <td colspan="4" class="text-muted">
                  <i class="fa fa-circle-info"></i> No se encontraron destinos.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <app-simple-pagination
          id="destinations-pag"
          [sizes]="[5,10,20]"
          (changed)="selectedDestinationId = null; refreshDestinationsPagination()"
          [elements]="paginationDestinations">
        </app-simple-pagination>
      </div>

      <!-- Tabla de Listas de Precio -->
      <div class="col">
        <div class="form-group">
          <label class="form-label">Buscar lista de precio</label>
          <input type="text" [(ngModel)]="filterPriceLists" (input)="debouncedFilterPriceLists()"
                 class="form-control" placeholder="Nombre o descripción de lista" />
        </div>

        <div class="table-responsive mt-3">
          <table class="table table-bordered" id="table-pricelists">
            <thead>
              <tr class="tr-middle">
                <th></th>
                <th>Nombre</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let p of priceLists"
                  [attr.data-id]="p.id"
                  (click)="togglePriceList(p)"
                  [class.selected]="currentRelatedPriceListIds.includes(p.id)">
                <td>
                  <i [ngClass]="currentRelatedPriceListIds.includes(p.id) ? 'fa-solid fa-circle' : 'fa-regular fa-circle'"></i>
                </td>
                <td>{{ p.name }}</td>
              </tr>

              <tr *ngIf="priceLists.length === 0">
                <td colspan="4" class="text-muted">
                  <i class="fa fa-circle-info"></i> No se encontraron listas de precios.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <app-simple-pagination
          id="pricelists-pag"
          [sizes]="[5,10,20]"
          (changed)="refreshPriceListsPagination()"
          [elements]="paginationPriceLists">
        </app-simple-pagination>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col" *ngIf="selectedDestination">
        <h5>Detalles del destino</h5>
        <ul class="list-group">
          <!-- <li class="list-group-item"><strong>Código:</strong> {{ selectedDestination.code }}</li> -->
          <li class="list-group-item"><strong>Nombre:</strong> {{ selectedDestination.name }}</li>
          <!-- <li class="list-group-item"><strong>Dirección:</strong> {{ selectedDestination.address }}</li> -->
        </ul>
      </div>

      <div class="col" *ngIf="currentRelatedPriceListIds && currentRelatedPriceListIds.length > 0">
        <h5>Listas de Precio Asociadas</h5>
        <ul class="list-group">
          <li *ngFor="let p of currentRelatedPriceLists" class="list-group-item">
            {{ p.name }}
          </li>
        </ul>
      </div>

      <div *ngIf="selectedDestinationId" class="d-flex flex-row justify-between mt-3">
        <button class="btn btn-success" [disabled]="getDisabledSave()" (click)="saveAssociation(false)">
          <ng-container *ngIf="!loading">
            <i class="fa fa-floppy-disk"></i>
          </ng-container>
          <ng-container *ngIf="loading">
            <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
          </ng-container>
          GUARDAR CAMBIOS
        </button>

        <!-- <button class="btn btn-info" [disabled]="getDisabledSave()" (click)="saveAssociation(true)">
          <ng-container *ngIf="!loading">
            <i class="fa fa-check-circle"></i>
          </ng-container>
          <ng-container *ngIf="loading">
            <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
          </ng-container>
          FINALIZAR Y GUARDAR
        </button> -->
      </div>
    </div>
  </div>
</div>
